import PropTypes from 'prop-types';

import WorkOrderInboundOperateForm from './WorkOrderInboundOperateForm';
import WorkOrderInboundSummaryCard from './WorkOrderInboundSummaryCard';

const WorkOrderInboundShell = ({ detail, receiptId = null }) => (
  <div className="space-y-4">
    <WorkOrderInboundSummaryCard detail={detail} />
    <WorkOrderInboundOperateForm detail={detail} receiptId={receiptId} />
  </div>
);

WorkOrderInboundShell.propTypes = {
  detail: PropTypes.object.isRequired,
  receiptId: PropTypes.string,
};

export default WorkOrderInboundShell;
